<div [formGroup]="form">
  <ng-container formArrayName="questionsArray">
    @for (_ of questionsArray.controls; track _; let q = $index) {
      <div [formGroupName]="q">
        <!-- question line -->
        <div class="question-line">
          <div class="question-num">{{(q+1)}}.</div>
          <mat-form-field class="flex-filler">
            <mat-label translate>Question</mat-label>
            <input matInput [formControlName]="'question'">
          </mat-form-field>
          @if ((q + 1) < questionsArray.length) {
            <mat-icon class="app-rule-engine-action-icon arrow"
              [matTooltip]="'Move question down' | translate" matTooltipPosition="above"
              (click)="onQuestionDown(q)">south
            </mat-icon>
          }
          @if (q > 0) {
            <mat-icon class="app-rule-engine-action-icon arrow"
              [matTooltip]="'Move question up' | translate" matTooltipPosition="above"
              (click)="onQuestionUp(q)">north
            </mat-icon>
          }
          @if (questionsArray.length > 1) {
            <mat-icon class="app-rule-engine-action-icon delete"
              [matTooltip]="'Remove the question' | translate" matTooltipPosition="above"
            (click)="onDeleteQuestion(q)">remove_circle</mat-icon>
          }
        </div>
        <!-- answers -->
        <div class="answers-container" formArrayName="answers">
          <div class="answers-title" translate>Answers</div>
          @for (_ of answersArray(q).controls; track _; let a = $index) {
            <div class="answer-line">
              <mat-form-field class="flex-filler" subscriptSizing="dynamic" [hideRequiredMarker]="true">
                <mat-label></mat-label>
                <input matInput [formControlName]="a">
              </mat-form-field>
              <mat-icon class="app-rule-engine-action-icon"
                [style.visibility]="answersArray(q).length === 1 ? 'hidden' : 'visible'"
                [matTooltip]="'Remove the answer' | translate" matTooltipPosition="above"
              (click)="onDeleteAnswer(q, a)">remove_circle</mat-icon>
            </div>
          }
          @if (answersArray(q).length < 10) {
            <div class="answer-actions">
              <a class="app-rule-engine-action" (click)="onAddAnswer(q)" href="javascript:void(0);">
              + {{'Add an Answer' | translate}}</a>
            </div>
          }
        </div>
      </div>
    }
  </ng-container>

  @if (questionsArray.length < 10) {
    <div class="question-actions">
      <a class="app-rule-engine-action" (click)="onAddQuestion()" href="javascript:void(0);" translate>
      + {{'Add a Question' | translate}}</a>
    </div>
  }

</div>